var map = {
	"./assets/about/about-modelling.png": "d25a",
	"./assets/about/about-principles.png": "9e78",
	"./assets/about/about-processing.png": "75d3",
	"./assets/about/about-results.png": "628a",
	"./assets/about/about-site.png": "bbcc",
	"./assets/about/about-workflow.png": "46ab",
	"./assets/about/doc.svg": "cc98",
	"./assets/about/es-frbr-en.svg": "fdce",
	"./assets/about/es-frbr.svg": "39a0",
	"./assets/about/es-ont-en.svg": "2363",
	"./assets/about/es-ont.svg": "432a",
	"./assets/about/es-rdf-en.svg": "7ed5",
	"./assets/about/es-rdf.svg": "0254",
	"./assets/about/kwickk-1.gif": "5ddd",
	"./assets/about/kwickk-2.gif": "ab21",
	"./assets/about/kwickk-3.gif": "fcdf",
	"./assets/about/meta.svg": "e2f7",
	"./assets/about/site-map.svg": "ad77",
	"./assets/about/voc-en.svg": "2d3d",
	"./assets/about/voc.svg": "475f",
	"./assets/about/wf-contents-example.svg": "53fa",
	"./assets/about/wf-contents.svg": "6aaf",
	"./assets/about/wf-documentation-example.svg": "731d",
	"./assets/about/wf-home.svg": "49a7",
	"./assets/about/wf-index-example.svg": "00d1",
	"./assets/about/wf-indexes.svg": "b6c7",
	"./assets/about/wf-project.svg": "9354",
	"./assets/about/wf-search.svg": "6818",
	"./assets/about/wf-work-example-metadata.svg": "9d50",
	"./assets/about/wf-work-example-text.svg": "7f4c",
	"./assets/about/wf-works.svg": "4e37",
	"./assets/about/workflow-en.svg": "93aa",
	"./assets/about/workflow.svg": "bb71",
	"./assets/edition/advance_search.png": "5660",
	"./assets/edition/editorial_plan.png": "6111",
	"./assets/edition/editorial_plan/Sezione Scritti e Discorsi ipotesi B.jpeg": "62ee",
	"./assets/edition/editorial_plan/diario.jpg": "04fe",
	"./assets/edition/editorial_plan/intervista_scalfari.jpg": "eedd",
	"./assets/edition/editorial_plan/memoriale.jpg": "563f",
	"./assets/edition/editorial_plan/s1.jpeg": "7b59",
	"./assets/edition/editorial_plan/s1v1.jpeg": "afbf",
	"./assets/edition/editorial_plan/s1v2.jpeg": "16db",
	"./assets/edition/editorial_plan/s1v2t1.jpeg": "d9b6",
	"./assets/edition/editorial_plan/s1v2t2.jpeg": "c7b2",
	"./assets/edition/editorial_plan/s1v3.jpeg": "e664",
	"./assets/edition/editorial_plan/s1v3t1.jpg": "5210",
	"./assets/edition/editorial_plan/s1v3t2.jpg": "daff",
	"./assets/edition/editorial_plan/s1v4.jpg": "b280",
	"./assets/edition/editorial_plan/s1v4t1.jpeg": "5aec",
	"./assets/edition/editorial_plan/s1v4t2.jpeg": "e0f5",
	"./assets/edition/editorial_plan/s2.jpeg": "235e",
	"./assets/edition/editorial_plan/s2v1.jpg": "05b8",
	"./assets/edition/editorial_plan/s2v2.jpeg": "8333",
	"./assets/edition/editorial_plan/s2v3.jpeg": "4c6c",
	"./assets/edition/editorial_plan/s2v4.jpeg": "4814",
	"./assets/edition/home.jpeg": "80bd",
	"./assets/edition/indices.jpeg": "d636",
	"./assets/edition/indices/bibliography.jpeg": "cb0b",
	"./assets/edition/indices/organizations.jpeg": "6bcb",
	"./assets/edition/indices/people.jpeg": "59e0",
	"./assets/edition/indices/places.png": "f783",
	"./assets/logo.png": "cf05",
	"./assets/logo.svg": "9b19",
	"./assets/moroHead.png": "0121",
	"./assets/treccaniLogo.png": "0bca",
	"./assets/treccaniLogo.svg": "11a8",
	"./assets/treccaniLogoPrimary.png": "87e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";